/**
 * Check for session storage and that it actually works
 */

const supportsStorage = function () {
	var testString = "this is the test string";
	var result;
	try {
		window.sessionStorage.setItem(testString, testString);
		result =
			window.sessionStorage.getItem(testString) === testString.toString();
		window.sessionStorage.removeItem(testString);
		return result;
	} catch (exception) {
		if (
			typeof console === "undefined" ||
			typeof console.log === "undefined"
		) {
			console.log("Notice: sessionStorage not available.");
		}
	}
};

function Toggle($module) {
	this.$module = $module;
	this.themeName = $module.getAttribute("data-toggles");
	this.supportsStorage = supportsStorage();
	this.isChecked = "false";
	this.storageKey = "COLOR_SCHEME";
	this.isSysPrefDark = '';
	this.isSysPrefLight = '';
	this.isSysPrefHighContrast = window.matchMedia("(prefers-contrast: more)");
	this.isSysPrefReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)"
	);
}

/**
 * Set up the toggle button
 */
Toggle.prototype.init = function () {
	if (!this.$module) {
		return;
	}

	this.$module.setAttribute("role", "switch");

	this.getInitialState();
	this.setInitialState();

	this.$module.boundOnClick = this.handleClick.bind(this);
	this.$module.addEventListener("click", this.$module.boundOnClick, false);
};

/**
 * Get initial toggle state from session storage
 */
Toggle.prototype.getInitialState = function () {
	if (this.supportsStorage) {
		let storedState = window.sessionStorage.getItem(this.storageKey);

		if (this.themeName === "dark") {
			if (storedState === "light") this.isChecked = true;
			if (storedState === "dark") this.isChecked = true;
		} else {
			this.isChecked = storedState === this.themeName;
		}
	}

	return this.isChecked;
};

/**
 * Set initial toggle state and save to session storage
 */
Toggle.prototype.setInitialState = function () {
	const root = document.documentElement;
	const store = window.sessionStorage;
	let storedState = window.sessionStorage.getItem(this.storageKey);

	if (this.themeName === "dark" && this.isSysPrefDark.matches) {
		root.setAttribute("data-user-color-scheme", "dark");
		this.$module.setAttribute("data-state", "dark");
		store.setItem(this.storageKey, "dark");
	}

	if (this.isChecked) {
		// root.setAttribute('data-user-color-scheme', this.themeName);
		if (this.themeName === "dark") {
			if (storedState === "light") {
				root.setAttribute("data-user-color-scheme", "light");
				this.$module.setAttribute("data-state", "light");
				store.setItem(this.storageKey, "light");
			} else if (storedState === "dark") {
				root.setAttribute("data-user-color-scheme", "dark");
				this.$module.setAttribute("data-state", "dark");
				store.setItem(this.storageKey, "dark");
			}
		} else {
			root.setAttribute("data-user-color-scheme", this.themeName);
			store.setItem(this.storageKey, this.themeName);
		}
	}

	this.$module.setAttribute("aria-checked", this.isChecked);
};

/**
 * Change and save toggle state on click
 */
Toggle.prototype.handleClick = function () {
	const root = document.documentElement;
	const store = window.sessionStorage;
	let storedState = window.sessionStorage.getItem(this.storageKey);

	let isChecked = this.$module.getAttribute("aria-checked") === "true";

	const $toggles = document.querySelectorAll(".js-toggle");

	for (const thisToggle of $toggles) {
		thisToggle.removeAttribute("aria-checked");
	}

	if (isChecked) {
		/*
        root.removeAttribute('data-user-color-scheme');

        // this.$module.removeAttribute('aria-checked');
        store.removeItem(this.storageKey, this.themeName);
        */

		if (this.themeName === "dark") {
			if (root.getAttribute("data-user-color-scheme") === "dark") {
				root.setAttribute("data-user-color-scheme", "light");
				this.$module.setAttribute("data-state", "light");
				store.setItem(this.storageKey, "light");
			} else {
				root.setAttribute("data-user-color-scheme", "dark");
				this.$module.setAttribute("data-state", "dark");
				store.setItem(this.storageKey, "dark");
			}
		} else {
			if (storedState === "high-contrast") {
				root.setAttribute(
					"data-user-color-scheme",

					// document.getElementById('toggle-dark').getAttribute('data-state')
					document
						.querySelector('[data-toggles="dark"]')
						.getAttribute("data-state")
				);
				store.setItem(
					this.storageKey,

					document
						.querySelector('[data-toggles="dark"]')
						.getAttribute("data-state")
				);

				const $toggleDarkButtons = document.querySelectorAll(
					'[data-toggles="dark"]'
				);
				for (const $toggleDarkButton of $toggleDarkButtons) {
					$toggleDarkButton.setAttribute("aria-checked", "true");
				}

				this.$module.setAttribute("aria-checked", "false");
			} else {
				root.setAttribute("data-user-color-scheme", this.themeName);
				store.setItem(this.storageKey, this.themeName);
			}
		}
	} else {
		root.setAttribute("data-user-color-scheme", this.themeName);
		this.$module.setAttribute("aria-checked", "true");
		store.setItem(this.storageKey, this.themeName);
	}

	this.isChecked = !this.isChecked;
};
// export default Toggle;

const $toggles = document.querySelectorAll(".js-toggle");
for (const $toggle of $toggles) {
	new Toggle($toggle, $toggles).init();
}

const ConvertRemToPixels = (SuperClass) =>
	class extends SuperClass {
		convertRemToPixels(rem) {
			return (
				parseFloat(rem) *
				parseFloat(getComputedStyle(document.documentElement).fontSize)
			);
		}
	};

// export default ConvertRemToPixels;

// TODO: handle resizes
// TODO: handle initial header fixed state, when initial scrollTop > offset

class Header extends ConvertRemToPixels(class {}) {
	constructor($module) {
		super();

		this.$module = $module;
		this.lastScrollTop = this.getScrollTop();
		this.scrollDirectionIsDown = false;

		this.isFixed = false;
		this.hasBigHeader = $module.classList.contains("c-header--big");
		this.isBig = this.hasBigHeader;
		this.isScrolling;
		this.eventHeaderHide = new Event("headerHide", {
			bubbles: true,
		});

		// Use the header’s height as the offset
		this.offset = this.convertRemToPixels(
			getComputedStyle(this.$module).getPropertyValue("--height-header")
		);

		// bind `this` to methods where needed
		this.handleScroll = this.handleScroll.bind(this);
		this.handleScrollListenerTimeout =
			this.handleScrollListenerTimeout.bind(this);
	}

	init() {
		window.addEventListener("scroll", this.handleScroll);

		// console.log('this.offset: ', this.offset);
	}

	getScrollTop() {
		// Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	handleScroll() {
		const currentScrollTop = this.getScrollTop();
		if (currentScrollTop > this.lastScrollTop) {
			if (this.scrollDirectionIsDown) {
				if (currentScrollTop >= this.offset && !this.isFixed) {
					this.toggleFixed();
				}
				if (currentScrollTop >= this.offsetPoint) {
					this.toggleVisibility();
					this.$module.dispatchEvent(this.eventHeaderHide);
				}
			} else {
				this.scrollDirectionIsDown = true;
				this.offsetPoint = this.getScrollTop() + this.offset;
			}
		} else {
			if (currentScrollTop <= 0 && this.isFixed) {
				this.toggleFixed();
			}
			if (this.scrollDirectionIsDown) {
				this.scrollDirectionIsDown = false;
				this.toggleVisibility();
			}
		}
		this.lastScrollTop = currentScrollTop;
	}

	toggleSize() {
		if (this.isBig) {
			this.$module.classList.remove("c-header--big");
		} else {
			this.$module.classList.add("c-header--big");
		}
		this.isBig = !this.isBig;
	}

	toggleFixed() {
		if (this.hasBigHeader) {
			this.toggleSize();
		}
		if (this.isFixed) {
			this.$module.classList.remove("is-fixed");
			this.$module.classList.remove("is-visible");
		} else {
			this.$module.classList.add("is-fixed");
		}
		this.isFixed = !this.isFixed;
	}

	toggleVisibility() {
		this.offsetPoint = undefined;
		if (this.scrollDirectionIsDown) {
			this.$module.classList.remove("is-visible");
		} else {
			this.$module.classList.add("is-visible");
		}
	}

	setScrollListenerTimeout() {
		if (this.getScrollTop() > 0) {
			window.removeEventListener("scroll", this.handleScroll);
			window.addEventListener("scroll", this.handleScrollListenerTimeout);
		}
	}

	handleScrollListenerTimeout() {
		window.clearTimeout(this.isScrolling);
		this.isScrolling = setTimeout(() => {
			window.removeEventListener(
				"scroll",
				this.handleScrollListenerTimeout
			);
			window.addEventListener("scroll", this.handleScroll);
		}, 50);
	}
}

// export default Header;

const $header = document.getElementsByClassName("js-header")[0];
let header;

if ($header) {
	header = new Header($header);
	header.init();
}

class ElementHasLink {
	constructor($module) {
		this.$teaser = $module;
		this.$mainLink = this.$teaser.querySelector(".js-element-link");

		// bind `this` to methods where needed
		this.addClickListener = this.addClickListener.bind(this);
		this.handleTeaserClick = this.handleTeaserClick.bind(this);
	}
	init() {
		if (!this.$teaser || !this.$mainLink) {
			return;
		}
		window.addEventListener("DOMContentLoaded", this.addClickListener);
	}
	addClickListener() {
		window.removeEventListener("DOMContentLoaded", this.addClickListener);
		const $clickables = this.$teaser.querySelectorAll("a, button");

		// Listen for clicks on teaser
		this.$teaser.addEventListener("click", this.handleTeaserClick);

		// Listen for clicks on clickable elements inside teaser
		$clickables.forEach(function ($clickable) {
			$clickable.addEventListener("click", function (event) {
				// Don’t bubble up and trigger main link when a button or link is clicked
				event.stopPropagation();
			});
		});
	}
	// Trigger main link when teaser is clicked, unless text
	// is being selected
	// TODO: handle clicks on modal buttons
	handleTeaserClick(event) {
		const noTextSelected = !window.getSelection().toString();
		// const isNotFancyBox = !event.target.hasAttribute('data-fancybox');
		// if (noTextSelected && isNotFancyBox) {
		if (noTextSelected) {
			this.$mainLink.click();
		}
	}
}

// export default TeaserHasLink;

const $elementsHasLink = document.getElementsByClassName("js-element-has-link");
for (const $elementHasLink of $elementsHasLink) {
	new ElementHasLink($elementHasLink).init();
}

/*
$(document).ready(function(){

	var $navFlyoutLevel2 = $('.c-nav-main__list-level-2');

    $navFlyoutLevel2.isotope(
    {
        itemSelector: '.c-nav-main__item-level-2',
        layoutMode: 'masonry'
    });
});
*/

$(document).ready(function () {
	$(".c-nav-main__action-button-level-2").on("click", function (e) {
		e.preventDefault();

		if ($(this).next().hasClass("show")) {
			$(".c-nav-main__list-level-3").hide().removeClass("show");
			$(this).next().hide();
		} else {
			$(".c-nav-main__list-level-3").hide().removeClass("show");
			$(this).next().show();
			$(this).next().addClass("show");
		}
	});
});
